import React, { Component, PropTypes } from 'react';
import { formatNumber, DateFormatter } from '../../utils/date';
import forEach from 'lodash/forEach';
import css from './comments.scss';

//Form elements
import Form from '../form/form';
import InputTextarea from '../form/input/textarea';
import InputSubmit from '../form/input/submit';

import {redirectToPathIf} from '../../utils/authorization';
import { accountRoute } from '../../routes';

import Share from '../../components/share/share';

export default class Comments extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			waiting: false,
			formErrors: {},
			formValues: {},
			comments: [],
		};
	}

	//@TODO: Fix lige noget should update på login/ud

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props.users._id !== nextProps.users._id ||
			this.props.comments.length !== nextProps.comments.length ||
			this.props.title !== nextProps.title ||
			this.state !== nextState
		);

	}

	componentWillMount() {
		this.state.comments = this.props.comments;
	}

	componentWillUpdate(nextProps, nextState) {
			if (this.props.title !== nextProps.title) {
				this.state.comments = nextProps.comments;
			}
	}

	render() {

		let comments = this.state.comments;
		let formErrors = (typeof this.state.formErrors === 'object') ? this.state.formErrors : {};
		let formValues = (typeof this.state.formValues === 'object') ? this.state.formValues : {};

		return (
			<section className='comments span14' id='comments'>
				<div className='comments__top span14'>
					<div className='comments__top__share'>
						<Share title={this.props.title} url={window.location.href} browser={this.props.browser} />
					</div>
					<h2 className='comments__title'>Discuss the project</h2>
				</div>
				<div className='comments__bottom span14'>
					<Form className='comments__reply span5 span14-mobile' getRefs={() => this.getRefs()} commentForm={true} method='post' action={'/api/cases/' + this.props.slug + '/comments'} ref='form' onSubmit={this.onFormSubmit.bind(this)}>
						<InputTextarea
							name='comment'
							ref='comment'
							value=''
							placeholder='Write a comment / question'
							rows={5}
							className='comments__message'
						/>
						<InputSubmit className='comments__send' name='Post Comment' value='Post Comment' waiting={this.state.waiting} />
						{!this.props.users.isLoggedIn() && (
						<a href='#' className='button comments__login' onClick={(event) => this.login(event)}>Login</a>
						)}
					</Form>
					<div className='comments__comments span9 span14-mobile'>
						<span className='comments__count'>{'(' + this.state.comments.length + ') COMMENTS'}</span>
						{this.state.comments && (
						<ul className='comments__comments-holder' ref='commentHolder'>
							{this.state.comments.map((comment, i) => this.renderComment(comment, i))}
						</ul>
						) || null}
						{this.state.comments && this.state.comments.length > 2 && (
						<a href='#' ref='commentMore' className='comments__more span9 pixel-pattern span14-mobile' onClick={(event) => { this.commentsToggle(event); }}>
							<span className='comments__more__text hide-mobile'>{'Load more (' + (this.state.comments.length - 2) + ')'}</span>
							<span className='comments__more__text hide-desktop hide-tablet'>Load more</span>
							<span className='comments__more__arrow'></span>
						</a>
						) || (
						<span href='#' className='comments__more span9 pixel-pattern span14-mobile'>
						</span>
						)}
					</div>
				</div>
			</section>
		);
	}

	login(e) {
		e.preventDefault();
		redirectToPathIf(this.props.dispatch, accountRoute('/login'), !this.props.users.isLoggedIn(), true);
	}

	onFormSubmit(promise) {
		if (this.refs.form && this.refs.form.serialize) {
			this.setState({ ...this.state, waiting: true });

			promise
			.then((resp) => {
				let comment = resp.data.comments;

				comment.new = true;

				this.state.comments.unshift(comment);

				this.refs.comment.clear();

				if (this.state.comments[1]) {
					this.state.comments[1].new = false;
				}

				this.setState({
					...this.state,
					comments: this.state.comments,
					waiting: false,
					formErrors: {},
				});
			})
			.catch((resp) => {
				if (resp.status !== 401) {
					console.log(resp.data.errors);
					this.setState({
						...this.state,
						waiting: false,
						formErrors: (typeof resp.data.errors === 'object') ? resp.data.errors : {},
					});
				} else {
					let error = {
						Login: ['You need to login!'],
					};

					console.log(error);
					this.setState({
						...this.state,
						waiting: false,
						formErrors: error,
					});
				}

			});
		}
	}

	getRefs() {
		return [this.refs.comment];
	}

	hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	singleCommentToggle(e, reference) {
		e.preventDefault();

		let commentContent = this.refs[reference].childNodes[1];
		let commentHolder = this.refs.commentHolder;
		let height = commentContent.childNodes[0].offsetHeight + 40;
		height += 40;
		let holderHeight = 0;

		if (!this.hasClass(commentContent, 'active')) {
			commentContent.classList.add('active');
			holderHeight -= 117;
			holderHeight += height;
			commentContent.style.maxHeight = height + 'px';
		} else {
			commentContent.style.maxHeight = '76px';
			commentContent.classList.remove('active');
			holderHeight += 117;
			holderHeight -= height;
		}

		if (this.hasClass(commentHolder, 'active')) {
			forEach(commentHolder.childNodes, function(comment, i) {
				holderHeight += comment.offsetHeight;
			});
		} else {
			forEach(commentHolder.childNodes, function(comment, i) {
				if (i < 2) {
					holderHeight += comment.offsetHeight;
				}
			});
		}

		commentHolder.style.maxHeight = holderHeight + 'px';
	}

	commentsToggle(e) {
		e.preventDefault();

		let commentHolder = this.refs.commentHolder;
		let commentMore = this.refs.commentMore;
		let holderHeight = 0;

		if (this.hasClass(commentHolder, 'active')) {
			commentHolder.classList.remove('active');
			forEach(commentHolder.childNodes, function(comment, i) {
				if (i < 2) {
					holderHeight += comment.offsetHeight;
				}
			});
		} else {
			commentHolder.classList.add('active');
			forEach(commentHolder.childNodes, function(comment, i) {
				holderHeight += comment.offsetHeight;
			});
		}

		if (this.hasClass(commentMore, 'active')) {
			commentMore.classList.remove('active');
		} else {
			commentMore.classList.add('active');
		}

		commentHolder.style.maxHeight = holderHeight + 'px';
	}

	renderComment(comment, i) {
		let createdDate = new DateFormatter(comment.timestamp * 1000);
		let uid = comment.id || ('comment' + i);

		let extra = '';

		if (comment.new) {
			extra += 'comments__comment--new';

			let _this = this;

			let timeout = setTimeout(function() {
				_this.refs[uid].classList.remove(extra);
			}, 500);
		}

		let returnNum = 0;

		if (comment.comment.split('\n')) {
			returnNum = comment.comment.split('\n').length;
		}

		return (
			<li key={uid} ref={uid} className={'comments__comment span9 span14-mobile ' + extra}>
				<div className='span2 span3-tablet comments__comment__left span14-mobile'>
					<h3 className='comments__comment__name'>{comment.users.name}</h3>
					<h4 className='comments__comment__date'>{createdDate.date} {createdDate.month} {createdDate.prettyTime}</h4>
				</div>
				{(comment.comment.length > 177 || returnNum > 2) && (
				<div className='comments__comment__content span5 comments__comment__content--has-more span14-mobile'>
					<p className='comments__comment__text span4 span12-mobile'>{comment.comment}</p>
					<a href='#' className='comments__comment__content--more button' onClick={(event) => { this.singleCommentToggle(event, uid); }}>...</a>
				</div>
				) || (
				<div className='comments__comment__content span7 span14-mobile'>
					<p className='comments__comment__text span4 span12-mobile'>{comment.comment}</p>
				</div>
				)}
			</li>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/comments/comments.js
 **/